import Vue from "vue";
import Vuex from "vuex";
import axios from "axios";

import {
  getIdToken,
  getAccessToken,
  getBaseUrl,
  getProvider
} from "./utils/auth";

Vue.use(Vuex);

const user =
  localStorage.getItem("user") !== "undefined"
    ? JSON.parse(localStorage.getItem("user"))
    : null;

let statusClass = []
statusClass['en_attente'] = []
statusClass['en_attente']['bullet'] = 'bullet red-bullet'
statusClass['en_attente']['icon'] = 'fa fa-spinner'
statusClass['brouillon'] = []
statusClass['brouillon']['bullet'] = 'bullet warning-bullet'
statusClass['brouillon']['icon'] = 'fa fa-check'
statusClass['a_traiter'] = []
statusClass['a_traiter']['bullet'] = 'bullet warning-bullet'
statusClass['a_traiter']['icon'] = 'fa fa-paper-plane'
statusClass['valide'] = []
statusClass['valide']['bullet'] = 'bullet green-bullet'
statusClass['valide']['icon'] = 'fa fa-check'
statusClass['affecte'] = []
statusClass['affecte']['bullet'] = 'bullet warning-bullet'
statusClass['affecte']['icon'] = 'fa fa-cog'

const state = {
  user,
  isLoading: false,
  msg: "",
  regMail: /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  regPassword: /^(?=.*\d)(?=.*[a-z])(?=.*[A-Z]).{8,}$/,
  regNumeric: /^[0-9]+$/,
  regAlpha: /^[A-zÀ-ú- ]+$/,
  regAlphaDash: /^[a-zA-Z- ]+$/,
  regAlphaUnderscore: /^[a-zA-Z_]+$/,
  regAlphaNumeric: /^[a-zA-Z0-9_]+$/,
  statusBulletClass: statusClass,
  selectedDossier: {},
  isFromLogin: false,
};

const getters = {
  getMsg: state => state.msg,
  getUser: state => state.user,
  getStatusBulletClass: state => state.statusBulletClass,
  getLoading: state => state.isLoading,
  getRegMail: state => state.regMail,
  getRegPassword: state => state.regPassword,
  getRegNumeric: state => state.regNumeric,
  getRegAlpha: state => state.regAlpha,
  getRegAlphaDash: state => state.regAlphaDash,
  getRegAlphaUnderscore: state => state.regAlphaUnderscore,
  getRegAlphaNumeric: state => state.regAlphaNumeric,
  getSelectedDossier: state => state.selectedDossier,
  getIsFromLogin: state => state.isFromLogin,
};

const mutations = {
  STORE_USER: (state, user) => {
    state.user = user;
  },
  FULL_STORE_USER: (state, user) => {
    state.user = user;
    localStorage.setItem('user', JSON.stringify(user));
  },
  HANDLE_USER: (state) => {
    state.user = localStorage.getItem("user") !== "undefined" ? JSON.parse(localStorage.getItem("user")) : null;
  },
  IS_LOADING: (state, value) => {
    state.isLoading = value;
  },
  SET_MESSAGE: (state, msg) => {
    state.msg = msg;
  },
  SET_SELECTED_DOSSIER: (state, dossier) => {
    state.selectedDossier = dossier;
  },
  IS_FROM_LOGIN: (state, value) => {
    state.isFromLogin = value;
  },
};

const actions = {
  retrieveUser: ({ commit }, userId) => {
    return new Promise( async (resolve) => {
      // let self = this
      let user = null;
      let originalUser = JSON.parse(localStorage.getItem("user"));

      let AUTH_TOKEN = getIdToken() + " " + getAccessToken();

      axios.defaults.baseURL = getBaseUrl();
      axios.defaults.headers.common["Authorization"] = AUTH_TOKEN;
      axios.defaults.headers.common["Accept"] = "application/json";
      axios.defaults.headers.common["Provider"] = getProvider();

      // On récupère les données de l'utilisateur
      axios
        .get("/espaceGestion/gestionnaire/enTantQue/" + userId)
        .then(response => {
          user = response.data.user;
          let userArray = Object.entries(user);
          for (const [key,value] of userArray) {
            originalUser[key] = value;
          }
          // console.log('originalUser',originalUser)
          commit("FULL_STORE_USER", originalUser);
          return resolve();
        })
        .catch(function(error) {
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log(error.response);
          } else if (error.request) {
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request);
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log("Error", error.message);
          }
          console.log(error.config);
          return resolve();
        });
    });
    
  },
  setBackUser({ commit }, user) {
    commit("FULL_STORE_USER", user);
  },
  setSelectedDossier({ commit }, dossier) {
    commit("SET_SELECTED_DOSSIER", dossier);
  },
  setIsFromLogin({ commit }, value) {
    commit("IS_FROM_LOGIN", value);
  }
};

let appstore = new Vuex.Store({
  state: state,
  mutations: mutations,
  getters: getters,
  actions: actions
});

export default appstore;
